
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manfred-daily",
      function () {
        return require("private-next-pages/manfred-daily.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manfred-daily"])
      });
    }
  